import type {FileRecord} from '@reados/contracts';

/** File kinds whose renderer is already known to be binary and needs no text probe. */
export function isKnownBinaryPreviewKind(kind:FileRecord['kind']|undefined):boolean {
 return kind==='pdf'||kind==='video'||kind==='image';
}

/** Parent Reader state for a known binary preview: false means binary, undefined keeps probing unknown kinds. */
export function initialTextDetection(kind:FileRecord['kind']|undefined):boolean|undefined {
 return isKnownBinaryPreviewKind(kind)?false:undefined;
}
